import axios from "axios";
import { getAccessToken } from "../utils/token-cookie";
import { env } from "../config/env";



export const apiClient = axios.create({
  baseURL: env.API_BASE_URL,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {

  // Si c'est du FormData → laisser Axios gérer automatiquement
  if (config.data instanceof FormData) {
    return config;
  }

  // Sinon → JSON par défaut
  if (config.headers) {
    config.headers.set("Content-Type", "application/json");
  }

  return config;
});


apiClient.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);


apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error.response?.status;
        console.error("API Error:", status);

        if (status === 401) {
            window.location.href = "/auth/login";
        }

        if (status === 403) {
            console.warn("Access forbidden.");
        }
        return Promise.reject(error);
    }
);

apiClient.interceptors.request.use((config) => {
    const token = getAccessToken();

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});